<div class="flex-col flex gap-6 justify-center grow">
  <span class="text-neutral-900 text-[32px] font-semibold leading-10">ViParts</span>

  <div class="flex flex-col gap-4">
    <span class="text-neutral-900 text-lg font-normal leading-[32px]">
      {{ 'login.welcome' | translate }}
    </span>
    <span class="w-72 text-zinc-500 text-sm font-normal leading-[21px]">
      {{ 'login.login' | translate }}
    </span>
  </div>

  <div class="flex-col flex gap-2">
    <button (click)="onLogin()" dsw-primary-button dsw-medium-button>
      {{ 'login.logging_in' | translate }}
    </button>
    <button (click)="onRegister()" dsw-secondary-button dsw-medium-button>
      {{ 'login.register' | translate }}
    </button>
  </div>

  <div class="grow"></div>

  @if (changeCatalogEnabled) {
  <button (click)="onChangeCatalog()" mat-button>
    {{ 'login.change_catalog' | translate }}
  </button>
  }
</div>
